import { PreferenceDomain } from '@/entities/preferences';
import { DeliveryPreferences } from '@/entities/preferences/delivery';
import { NotificationPreferences } from '@/entities/preferences/notification';
import { ReturnsPreferences } from '@/entities/preferences/returns';
import { validateResponse } from '@/utils/httpResponse';

type UpdateArguments =
  | {
      product: PreferenceDomain.Notification;
      body: NotificationPreferences;
    }
  | {
      product: PreferenceDomain.Delivery;
      body: DeliveryPreferences;
    }
  | {
      product: PreferenceDomain.Returns;
      body: ReturnsPreferences;
    };

async function updateUserPreferences(data: UpdateArguments) {
  const response = await fetch(`/api/preferences/${data.product}`, {
    method: 'PUT',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify(data.body),
  });

  await validateResponse(response);

  return response;
}

export { updateUserPreferences };
